<template>
  <div name="item-desc" class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choiceDisp}" @click="toggleChoiceDisp()">
    <div class="main-label" :class="{ 'active color-skin' : choiceDisp}"><label>{{choice.grad}} : {{choice.descgrd}} ({{choice.qtyscor}} {{labelScore}})</label></div>
    <div class="more-label" v-show="choiceDisp">{{choice.definit}}</div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'item-desc',
  data () {
    return {
      choiceDisp: false,
      labelScore: constLabels('score')
    }
  },
  props: [ 'dataGroup', 'item', 'choice' ],
  methods: {
    toggleChoiceDisp () {
      this.choiceDisp = !this.choiceDisp
    }
  }
}
</script>


// WEBPACK FOOTER //
// itemDesc.vue?47274a1a